import { QuotedContext } from 'components/common-form/contexts/QuotedContext';
import { useContext } from 'react';
export function useIsQuoted(): boolean {
  return useContext(QuotedContext);
}
